var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copy-input-container"},[_c('TextInput',{attrs:{"value":_vm.value,"readOnly":true}}),_c('FlexButton',{attrs:{"text":"Copy","whiteBlue":true},on:{"clicked":_vm.onCopy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }